export class DevolutionProjectionDetailModel {
    devolutionProjectionDetailId: number = 0;
    devolutionProjectionId: number = 0;
    articleId: number = 0;
    storeId: number = 0;
    quantity: number = 0;
    createDate: Date = new Date();
    userNameCreate: string = "";
    updateDate: Date | null = null;
    userNameUpdate: string | null = null;
    stock: number = 0;
}